import React from 'react'
import { Navigate, Route, Routes} from 'react-router-dom'

import {
  PublicOfferDashboardPage,
  PublicOfferDetailPage,
  PublicOfferCreatePage,
} from '../components'

export const PublicOfferRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<PublicOfferDashboardPage />} />
      <Route path="/new" element={<PublicOfferCreatePage />} />
      <Route path="/:publicOfferId" element={<PublicOfferDetailPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}
